// A small dropdown for the Sources filters (Type / Signal / mobile Orbit) — the
// shared Menu primitive. Replaces the native <select>, whose OS popup renders
// broken on mobile (dark, mispositioned). The trigger keeps its `.src-menu-btn`
// layout classes (and the mobile show/hide via `className`); the popover is now
// the canonical Menu.

import React from "react";
import { ChevronDown } from "lucide-react";
import { cn } from "@/lib/utils";
import { Menu, MenuItem } from "@/components/vb";

export interface FilterOption {
  value: string;
  label: string;
}

interface FilterMenuProps {
  value: string;
  options: FilterOption[];
  onChange: (value: string) => void;
  ariaLabel: string;
  /** Extra class on the trigger (e.g. `src-orbit-menu` for mobile-only show). */
  className?: string;
}

export function FilterMenu({ value, options, onChange, ariaLabel, className }: FilterMenuProps) {
  const current = options.find((o) => o.value === value) ?? options[0];
  const active = value !== "all";
  return (
    <Menu
      matchTrigger
      ariaLabel={ariaLabel}
      trigger={
        <button
          type="button"
          className={cn("vb-btn vb-btn--sm src-menu-btn", active && "on", className)}
          aria-label={ariaLabel}
        >
          <span className="src-menu-label">{current?.label}</span>
          <ChevronDown size={12} aria-hidden="true" />
        </button>
      }
    >
      {options.map((o) => (
        <MenuItem
          key={o.value}
          role="menuitemradio"
          selected={o.value === value}
          onSelect={() => onChange(o.value)}
        >
          {o.label}
        </MenuItem>
      ))}
    </Menu>
  );
}

export default FilterMenu;
